// --- FILE: src/App.jsx (CON LÓGICA DE ROLES ROBUSTA) ---
import React from 'react';
import { useAuth } from './contexts/AuthContext';

import AdminLoginPage from './pages/AdminLoginPage';
import AdminReportPage from './pages/AdminReportPage';
import NewDashboardPage from './pages/NewDashboardPage';
import AnalyticsScreen from './components/dashboard/AnalyticsScreen';
import ProductAnalyticsScreen from './components/dashboard/ProductAnalyticsScreen';
import ProductCostsScreen from './components/dashboard/ProductCostsScreen';
import KPIAnalyticsScreen from './components/dashboard/KPIAnalyticsScreen';
import DebugDynamiaERPPage from './pages/DebugDynamiaERPPage';
import FinanzasPage from './pages/FinanzasPage';
import VendedoresPage from './pages/VendedoresPage';
import { Route, Routes } from 'react-router-dom';
import PinScreenPage from './pages/PinScreenPage';
import EmployeeDashboardPage from './pages/EmployeeDashboardPage';
import LoadingSpinner from './components/common/LoadingSpinner';
import { Sidebar } from './components/layout/Sidebar';
import { MobileHeader, BottomNav } from './components/layout/MobileNav';

function App() {
  const { user, activeEmployee, loading, adminView, userRole } = useAuth();

  // 1. Estado de Carga
  if (loading) {
    return <LoadingSpinner fullScreen={true} text="Iniciando sistema..." />;
  }

  // 2. Vista del Empleado (Máxima prioridad)
  if (activeEmployee) {
    return <EmployeeDashboardPage />;
  }

  // 3. Vistas para Usuarios Autenticados (sin PIN activo)
  if (user) {
    // Si el rol es 'admin', decide qué panel mostrar
    if (userRole === 'admin') {
      if (adminView === 'terminal') {
        return <PinScreenPage />;
      }
      return (
        <div className="flex min-h-screen bg-gray-950 text-white">
          <Sidebar />
          <main className="flex-1 min-w-0 pb-20 md:pb-0">
            <MobileHeader />
            <Routes>
          <Route path="/" element={<AdminReportPage />} />
          <Route path="/dashboard-new" element={<NewDashboardPage />} />
          <Route path="/analytics" element={<AnalyticsScreen />} />
          <Route path="/products-analytics" element={<ProductAnalyticsScreen />} />
          <Route path="/product-costs" element={<ProductCostsScreen />} />
          <Route path="/kpi-analytics" element={<KPIAnalyticsScreen />} />
          <Route path="/finanzas" element={<FinanzasPage />} />
          <Route path="/vendedores" element={<VendedoresPage />} />
          <Route path="/debug-dynamia-erp" element={<DebugDynamiaERPPage />} />
            </Routes>
          </main>
          <BottomNav />
        </div>
      );
    }
    // Si el rol es 'employee', lo manda directamente al terminal
    if (userRole === 'employee') {
      return <PinScreenPage />;
    }
  }

  // 4. Vista por Defecto (Login)
  // Si no hay usuario o no tiene un rol reconocido, va al login.
  return <AdminLoginPage />;
}

export default App;
